import dayjs from "dayjs";

export const reformatEvents = (eventsData) => {
    const newEvents = []
    for (let i= 0; i < eventsData.length; i++) {
        const e = eventsData[i]
        // const time = e.schedule.split('-')
        newEvents.push({
            id: e.eventEntityId,
            title: e.label,
            start: dayjs(e.startDate).format("YYYY-MM-DD") + 'T' + e.startTime, // eg:2024-03-05T14:00:00
            end: dayjs(e.endDate).format("YYYY-MM-DD") + 'T' + e.endTime,
        })
    }
    return newEvents;
}